import React from 'react';
import { useLocalTimer } from '../hooks/useLocalTimer';
import { toast } from 'sonner';

export default function TimerDebugPage() {
  const { isRunning, currentTaskId, currentTaskTitle, displayTime, forceClearTimer, stopTimer } = useLocalTimer();
  
  const handleForceClear = () => {
    forceClearTimer();
    toast.success('Timer force cleared');
  };
  
  const handleNormalStop = () => {
    const elapsed = stopTimer();
    toast.success(`Timer stopped normally. Elapsed: ${elapsed}ms`);
  };
  
  const checkLocalStorage = () => {
    const state = localStorage.getItem('goalie4-timer-state');
    console.log('Current localStorage timer state:', state);
    if (state) {
      console.log('Parsed state:', JSON.parse(state));
    }
  };
  
  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Timer Debug Page</h1>
      
      <div className="bg-gray-100 p-4 rounded mb-6">
        <h2 className="font-semibold mb-2">Current Timer State</h2>
        <p>Is Running: <span className="font-mono">{isRunning ? 'true' : 'false'}</span></p>
        <p>Task ID: <span className="font-mono">{currentTaskId || 'none'}</span></p>
        <p>Task Title: <span className="font-mono">{currentTaskTitle || 'none'}</span></p>
        <p>Display Time: <span className="font-mono">{displayTime}</span></p>
      </div>
      
      <div className="space-y-4">
        <button
          onClick={checkLocalStorage}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Check localStorage (see console)
        </button>
        
        <button
          onClick={handleNormalStop}
          disabled={!isRunning}
          className="px-4 py-2 bg-yellow-600 text-white rounded hover:bg-yellow-700 disabled:opacity-50 ml-4"
        >
          Normal Stop Timer
        </button>
        
        <button
          onClick={handleForceClear}
          className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 ml-4"
        >
          Force Clear Timer
        </button>
      </div>
      
      <div className="mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded">
        <p className="text-sm">
          <strong>Note:</strong> Use Force Clear if the timer is stuck and won't clear normally.
          Check the browser console for debug logs.
        </p>
      </div>
    </div>
  );
}
